<div class="container-fluid p-1 p-lg-3 ">
  <div class="row g-0 px-3 px-lg-5">

    <!-- ── LEFT PANEL (hidden on mobile) ─────── -->
    <div class="col-lg-5 d-none d-lg-flex flex-column left-panel ">

      <!-- Back + Logo -->
      <div class="d-flex align-items-center gap-2 mb-5">
        <a class="text-white  text-decoration-none me-1" style="font-size:1.2rem;" (click)="landingPage()"><i
            class="bi bi-arrow-left"></i></a>
        <span class="brand-logo"> <a class=" pe-3" (click)="landingPage()" style="cursor: pointer">
            <img src="logo/agrify-ai-white.png" class="img-fluid" />
          </a></span>
      </div>

      <!-- Headline -->
      <h2 class="panel-title mb-4">Global Fruit Trade, Simplified.</h2>

      <!-- Features -->
      <div class="d-flex flex-column gap-3 mb-5">
        <div class="feature-item">
          <div class="feature-icon fi-green"><i class="bi bi-globe"></i></div>
          <div>
            <h6>Access Global Markets</h6>
            <p>Connect with verified buyers and sellers in over 120 countries instantly.</p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon fi-blue"><i class="bi bi-graph-up"></i></div>
          <div>
            <h6>AI-Driven Insights</h6>
            <p>Make smarter decisions with real-time price predictions and demand forecasting.</p>
          </div>
        </div>
        <div class="feature-item">
          <div class="feature-icon fi-purple"><i class="bi bi-shield-shaded"></i></div>
          <div>
            <h6>Secure Transactions</h6>
            <p>Trade with confidence using our escrow services and smart contracts.</p>
          </div>
        </div>
      </div>

      <!-- Testimonial -->
      <div class="mt-auto testimonial-card">
        <div class="stars mb-2">★★★★★</div>
        <p class="mb-3">"Agrify.ai revolutionized our export business. We found reliable buyers in Europe within our
          first week."</p>
        <div class="d-flex align-items-center gap-2">
          <div class="avatar">MR</div>
          <div>
            <div class="reviewer-name">Mateo Rodriguez</div>
            <div class="reviewer-role">FRUIT EXPORTER, CHILE</div>
          </div>
        </div>
      </div>

    </div>

    <!-- ── RIGHT PANEL ────────────────────────── -->
    <div class="col-12 col-lg-7 right-panel">
      <div style="max-width: 500px; width: 100%; margin: 0 auto;">

        <!-- Mobile logo (only shown on small screens) -->
        <div class="d-flex d-lg-none align-items-center gap-2 mb-4">
          <span class="brand-logo"> <img src="logo/agrify-ai-blue.png" class="img-fluid" /></span>
        </div>

        <h2 class="form-title mb-1">Welcome back</h2>
        <p class="form-subtitle mb-4">Sign in to continue to your account</p>

        <!-- Google Sign In -->
        <!-- <button class="btn btn-google w-100 d-flex align-items-center justify-content-center gap-2 mb-3">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.7 1.22 9.2 3.22l6.88-6.88C35.84 2.38 30.28 0 24 0 14.62 0 6.6 5.38 2.64 13.22l8.02 6.24C12.46 13.02 17.78 9.5 24 9.5z"/><path fill="#4285F4" d="M46.5 24.5c0-1.62-.14-3.18-.4-4.68H24v8.86h12.7c-.55 2.96-2.2 5.46-4.68 7.14l7.24 5.62C43.5 37.5 46.5 31.4 46.5 24.5z"/><path fill="#FBBC05" d="M10.66 28.54A14.5 14.5 0 0 1 9.5 24c0-1.58.28-3.1.76-4.54L2.24 13.22A23.94 23.94 0 0 0 0 24c0 3.86.92 7.5 2.56 10.72l8.1-6.18z"/><path fill="#34A853" d="M24 48c6.28 0 11.56-2.08 15.42-5.66l-7.24-5.62c-2.02 1.36-4.6 2.16-8.18 2.16-6.22 0-11.54-3.52-13.34-8.96l-8.1 6.18C6.6 42.62 14.62 48 24 48z"/><path fill="none" d="M0 0h48v48H0z"/></svg>
          Sign in with Google
        </button> -->

        <!-- Divider -->
        <!-- <div class="d-flex align-items-center gap-3 mb-3">
          <div class="divider-text d-flex align-items-center gap-3 w-100">
            <span></span>OR CONTINUE WITH EMAIL<span></span>
          </div>
        </div> -->

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <!-- Email/Phone Toggle -->
          <!-- <div class="text-end mb-2">
            <a href="javascript:void(0)" (click)="setLoginPrefrence()" class="forgot-link" style="font-size: 0.85rem;">
              {{ isPhoneNumber ? 'Sign in with Email' : 'Sign in with Phone' }}
            </a>
          </div> -->

          <!-- Email -->
          <div *ngIf="!isPhoneNumber" class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="form-label mb-0"
                [ngClass]="{ 'is-invalid-label': showError || ((submitted || f['username'].touched) && f['username'].errors) }">Email
                Address</label>
              <a href="javascript:void(0)" (click)="setLoginPrefrence()" class="forgot-link"
                style="font-size: 0.85rem;">
                {{ isPhoneNumber ? 'Sign in with Email' : 'Sign in with Phone' }}
              </a>
            </div>
            <div class="input-wrapper">
              <span class="input-icon"
                [ngClass]="{ 'is-invalid-icon': showError || ((submitted || f['username'].touched) && f['username'].errors) }"><i
                  class="bi bi-envelope"></i></span>
              <input type="email" formControlName="username" class="form-control form-control-custom w-100"
                [ngClass]="{ 'is-invalid': showError || ((submitted || f['username'].touched) && f['username'].errors) }"
                placeholder="name@company.com" />
            </div>
            <div *ngIf="(submitted || f['username'].touched) && f['username'].errors" class="text-danger mt-1"
              style="font-size: 0.75rem;">
              <span *ngIf="f['username'].errors?.['required']">Email is required</span>
              <span *ngIf="f['username'].errors?.['email']">Invalid email format</span>
              <span *ngIf="f['username'].errors['serverError']">{{ f['username'].errors['serverError'] }}</span>
            </div>
          </div>

          <!-- Phone -->
          <div *ngIf="isPhoneNumber" class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="form-label mb-0"
                [ngClass]="{ 'is-invalid-label': showError || ((submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors) }">Phone
                Number</label>
              <a href="javascript:void(0)" (click)="setLoginPrefrence()" class="forgot-link"
                style="font-size: 0.85rem;">
                {{ isPhoneNumber ? 'Sign in with Email' : 'Sign in with Phone' }}
              </a>
            </div>
            <!-- <div class="input-wrapper">
              <span class="input-icon"
                [ngClass]="{ 'is-invalid-icon': showError || ((submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors) }"><i
                  class="bi bi-telephone"></i></span>
              <input type="number" formControlName="phoneNumber" class="form-control form-control-custom w-100"
                [ngClass]="{ 'is-invalid': showError || ((submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors) }"
                placeholder="+1 234 567 890" />
            </div>
            <div *ngIf="(submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors" class="text-danger mt-1"
              style="font-size: 0.75rem;">
              <span *ngIf="f['phoneNumber'].errors?.['required']">Phone number is required</span>
              <span *ngIf="f['phoneNumber'].errors?.['serverError']">{{ f['phoneNumber'].errors?.['serverError']
                }}</span>
            </div> -->
            <div class="row g-3 mb-3">
              <div class="col-12">
                <!-- <label class="form-label"
                  [ngClass]="{ 'is-invalid-label': showError || ((submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors) }">Phone
                  Number <span class="text-danger">*</span></label> -->
                <div class="phone-input-group-v2">
                  <mat-select class="country-selector-v2 f-select-v2" 
                    [ngClass]="{'is-invalid': (submitted || f['phoneNumber'].touched) && f['phoneNumber'].invalid}"
                      [value]="selectedCountry"
                    (selectionChange)="onCountryChange($event.value)">
                    <mat-select-trigger>
                      <img [src]="'https://flagcdn.com/w20/' + (countryCode || 'us') + '.png'" width="20" class="me-2" />
                      <span>{{countryPhoneCode}}</span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let c of countries" [value]="c">
                      <img [src]="'https://flagcdn.com/w20/' + c.isoCode.toLowerCase() + '.png'" width="20" class="me-2" />
                      <span>{{c.name}} +({{c.phonecode}})</span>
                    </mat-option>
                  </mat-select>
                  <i class="bi bi-chevron-down select-chevron-v2" style="right: 0.75rem;"></i>
                  <input type="number" formControlName="phoneNumber" class="f-input-v2"
                    [ngClass]="{ 'is-invalid': showError || ((submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors) }"
                    placeholder="201 555 0123" />
                </div>
                <div class="field-error-v2 text-danger mt-1"
              style="font-size: 0.75rem;"
                  *ngIf="(submitted || f['phoneNumber'].touched) && f['phoneNumber'].errors">
                  <span *ngIf="f['phoneNumber'].errors?.['required']">Phone number is required</span>
                  <span *ngIf="f['phoneNumber'].errors?.['pattern']">Invalid phone number.</span>
                  <span *ngIf="f['phoneNumber'].errors['serverError']">{{ f['phoneNumber'].errors['serverError'] }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Password -->
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="form-label mb-0"
                [ngClass]="{ 'is-invalid-label': showError || ((submitted || f['password'].touched) && f['password'].errors) }">Password</label>
              <a routerLink="/forgot-password" class="forgot-link">Forgot password?</a>
            </div>
            <div class="input-wrapper">
              <span class="input-icon"
                [ngClass]="{ 'is-invalid-icon': showError || ((submitted || f['password'].touched) && f['password'].errors) }"><i
                  class="bi bi-lock-fill"></i></span>
              <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                class="form-control form-control-custom w-100"
                [ngClass]="{ 'is-invalid': showError || ((submitted || f['password'].touched) && f['password'].errors) }"
                placeholder="Enter your password" />
              <span class="input-icon-right" (click)="togglePasswordVisibility()" id="eyeIcon">
                <i [class]="showPassword ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </span>
            </div>
            <div *ngIf="(submitted || f['password'].touched) && f['password'].errors" class="text-danger mt-1"
              style="font-size: 0.75rem;">
              <span *ngIf="f['password'].errors?.['required']">Password is required</span>
            </div>
          </div>

          <!-- Error Message Block -->
          <div *ngIf="showError" class="login-error-alert mb-4">
            <div class="d-flex align-items-start gap-2">
              <i class="bi bi-exclamation-circle-fill fs-5"></i>
              <div>
                <div class="error-heading">Error</div>
                <div class="error-text">{{ message }}</div>
              </div>
            </div>
          </div>

          <!-- Remember me -->
          <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" id="rememberMe" formControlName="rememberMe" />
            <label class="form-check-label" for="rememberMe">Keep me signed in</label>
          </div>

          <!-- Submit -->
          <button type="submit" class="btn btn-signin w-100 mb-3" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
            {{ loading ? 'Signing In...' : 'Sign In' }} &nbsp;<i *ngIf="!loading" class="bi bi-arrow-right"></i>
          </button>
        </form>

        <!-- Create account -->
        <p class="text-center" style="font-size: 0.83rem; color: #64748b;">
          Don't have an account? <a href="#" class="create-link" routerLink="/registration">Create account</a>
        </p>
        <hr class="footer-divider">
        <!-- Footer -->
        <div class="d-flex justify-content-between align-items-center mt-5 flex-wrap gap-2">
          <span class="footer-copy">© 2025 Agrify.ai</span>
          <div class="footer-links d-flex gap-3">
            <a (click)="viewHelp()">Help</a>
            <a href="/pdfs/Privacy Policy.pdf" target="_blank">Privacy</a>
            <a href="/pdfs/T&C.pdf" target="_blank">Terms</a>
          </div>
        </div>

      </div>
    </div>


  </div>
</div>